(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("knockout"), require("ko-bindinghandler"), require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["knockout", "ko-bindinghandler", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["ycloud"] = factory(require("knockout"), require("ko-bindinghandler"), require("jquery"));
	else
		root["ycloud"] = factory(root["ko"], root[undefined], root["$"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_32__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition